<script setup lang="ts">
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";
import {InfoIcon} from "@lucide/vue";
</script>

<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger>
        <InfoIcon v-bind="$attrs" />
      </TooltipTrigger>
      <TooltipContent class="bg-primary font-medium text-base">
        <slot />
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<style scoped>

</style>
